// @mui
import { alpha, styled } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// config
import { ICON, NAVBAR } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body2,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(0.7),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius * 1.5,
  transition: theme.transitions.create(['background', 'box-shadow', 'color', 'border'], {
    duration: theme.transitions.duration.shorter,
  }),
  // Clean soft-pill hover
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.06),
    color: theme.palette.primary.main,
  },
  // activeRoot — soft indigo pill with an inset accent bar
  ...(activeRoot && {
    ...theme.typography.subtitle2,
    color: theme.palette.primary.main,
    background: alpha(theme.palette.primary.main, 0.12),
    '&:hover': { background: alpha(theme.palette.primary.main, 0.16) },
    // slim rounded accent bar on the left, tucked inside the pill
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 6,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 3,
      height: 18,
      borderRadius: 3,
      background: theme.palette.primary.main,
    },
  }),
  // activeSub
  ...(activeSub && {
    ...theme.typography.subtitle2,
    color: theme.palette.text.primary,
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
    paddingLeft: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      background: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});
